<svg
  width="100%"
  height="436"
  viewBox="0 0 258 436"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M280.943 234H118.346C115.749 234 113.645 236.4 113.645 239.36V322.64C113.645 325.6 115.749 328 118.346 328H280.943C283.54 328 285.645 325.6 285.645 322.64V239.36C285.645 236.4 283.54 234 280.943 234Z"
    fill="#362C7B"
  />
  <path
    d="M273.329 262.794H113.002V248.928H273.329C275.981 248.928 278.132 251.365 278.132 254.37V257.352C278.132 260.356 275.981 262.794 273.329 262.794Z"
    fill="#E974D6"
  />
  <mask
    id="mask0_956_7"
    style="mask-type:luminance"
    maskUnits="userSpaceOnUse"
    x="113"
    y="248"
    width="166"
    height="15"
  >
    <path
      d="M273.327 262.793H113V248.927H273.327C275.979 248.927 278.13 251.364 278.13 254.369V257.351C278.13 260.355 275.979 262.793 273.327 262.793Z"
      fill="white"
    />
  </mask>
  <g mask="url(#mask0_956_7)">
    <path
      d="M209.358 316.725L301.2 268.292L250.94 223.743L159.098 272.176L209.358 316.725Z"
      fill="#E968D4"
    />
    <path
      d="M134.185 275.336L189.883 245.964L183.222 240.06L127.523 269.432L134.185 275.336Z"
      fill="#E968D4"
    />
  </g>
  <path
    d="M273.329 289.684H113.002V275.818H273.329C275.981 275.818 278.132 278.256 278.132 281.26V284.242C278.132 287.247 275.981 289.684 273.329 289.684Z"
    fill="#E974D6"
  />
  <mask
    id="mask1_956_7"
    style="mask-type:luminance"
    maskUnits="userSpaceOnUse"
    x="113"
    y="275"
    width="166"
    height="15"
  >
    <path
      d="M273.327 289.683H113V275.817H273.327C275.979 275.817 278.13 278.255 278.13 281.259V284.242C278.13 287.246 275.979 289.683 273.327 289.683Z"
      fill="white"
    />
  </mask>
  <g mask="url(#mask1_956_7)">
    <path
      d="M177.142 361.079L305.623 293.326L237.367 232.831L108.887 300.585L177.142 361.079Z"
      fill="#E968D4"
    />
    <path
      d="M83.974 303.745L139.669 274.376L133.008 268.472L77.3125 297.84L83.974 303.745Z"
      fill="#E968D4"
    />
  </g>
  <path
    d="M273.329 315.893H113.002V302.027H273.329C275.981 302.027 278.132 304.465 278.132 307.469V310.451C278.132 313.456 275.981 315.893 273.329 315.893Z"
    fill="#E974D6"
  />
  <mask
    id="mask2_956_7"
    style="mask-type:luminance"
    maskUnits="userSpaceOnUse"
    x="113"
    y="302"
    width="166"
    height="14"
  >
    <path
      d="M273.327 315.891H113V302.025H273.327C275.979 302.025 278.13 304.463 278.13 307.467V310.449C278.13 313.454 275.979 315.891 273.327 315.891Z"
      fill="white"
    />
  </mask>
  <g mask="url(#mask2_956_7)">
    <path
      d="M280.146 300.244H112.725V318.017H280.146V300.244Z"
      fill="#E968D4"
    />
  </g>
  <path
    d="M9.74567 433.832L249.332 434C254.694 434 259.039 432.108 259.039 429.776V344.392C259.039 342.057 254.694 340.168 249.332 340.168L9.74567 340C4.38408 340 0.0390625 341.892 0.0390625 344.224V429.608C0.0390625 431.943 4.38408 433.832 9.74567 433.832Z"
    fill="#362C7B"
  />
  <path
    d="M177.993 368.534L0.00131226 368.366V354.5L177.993 354.668C182.461 354.668 186.084 356.561 186.084 358.894V364.304C186.084 366.641 182.461 368.531 177.993 368.531V368.534Z"
    fill="#BA74FF"
  />
  <mask
    id="mask3_956_7"
    style="mask-type:luminance"
    maskUnits="userSpaceOnUse"
    x="0"
    y="354"
    width="187"
    height="15"
  >
    <path
      d="M177.993 368.535L0.00131226 368.367V354.501L177.993 354.669C182.461 354.669 186.084 356.562 186.084 358.895V364.305C186.084 366.642 182.461 368.532 177.993 368.532V368.535Z"
      fill="white"
    />
  </mask>
  <g mask="url(#mask3_956_7)">
    <path
      d="M60.2479 383.259L4.37249 353.89L11.0562 347.986L66.9316 377.355L60.2479 383.259Z"
      fill="#AC59FF"
    />
    <path
      d="M29.1522 387.147L-26.7232 357.778L-20.0395 351.874L35.8359 381.243L29.1522 387.147Z"
      fill="#AC59FF"
    />
  </g>
  <path
    d="M177.993 395.422L0.00131226 395.254V381.388L177.993 381.555C182.461 381.555 186.084 383.449 186.084 385.782V391.192C186.084 393.528 182.461 395.418 177.993 395.418V395.422Z"
    fill="#BA74FF"
  />
  <mask
    id="mask4_956_7"
    style="mask-type:luminance"
    maskUnits="userSpaceOnUse"
    x="0"
    y="381"
    width="187"
    height="15"
  >
    <path
      d="M177.993 395.422L0.00131226 395.254V381.388L177.993 381.555C182.461 381.555 186.084 383.449 186.084 385.782V391.192C186.084 393.528 182.461 395.418 177.993 395.418V395.422Z"
      fill="white"
    />
  </mask>
  <g mask="url(#mask4_956_7)">
    <path
      d="M48.7549 419.598L-10.202 388.605L9.37517 371.308L68.332 402.3L48.7549 419.598Z"
      fill="#AC59FF"
    />
    <path
      d="M96.0575 407.319L40.1821 377.95L46.8658 372.046L102.738 401.415L96.0575 407.319Z"
      fill="#AC59FF"
    />
  </g>
  <path
    d="M177.992 422.263L-0.000610352 422.096V408.229L177.992 408.397C182.46 408.397 186.082 410.29 186.082 412.624V418.034C186.082 420.37 182.46 422.26 177.992 422.26V422.263Z"
    fill="#BA74FF"
  />
  <mask
    id="mask5_956_7"
    style="mask-type:luminance"
    maskUnits="userSpaceOnUse"
    x="0"
    y="408"
    width="187"
    height="15"
  >
    <path
      d="M186.084 422.26L0.00114441 422.096V408.229L186.084 408.476C186.084 411.391 186.084 410.29 186.084 412.624L186.084 422.26C182.683 422.257 183.898 422.258 177.994 422.26H186.084Z"
      fill="white"
    />
  </mask>
  <g mask="url(#mask5_956_7)">
    <path
      d="M64.4278 474.488L-27.6919 426.055L22.7201 381.51L114.84 429.94L64.4278 474.488Z"
      fill="#AC59FF"
    />
    <path
      d="M139.829 433.099L83.9634 403.73L90.646 397.826L146.512 427.195L139.829 433.099Z"
      fill="#AC59FF"
    />
  </g>
  <path
    d="M210.039 414.363V436H235.039V414.363C235.039 412.504 233.21 411 230.955 411H214.126C211.868 411 210.042 412.506 210.042 414.363H210.039Z"
    fill="#BA74FF"
  />
  <rect x="202.039" y="386" width="41" height="14" rx="7" fill="#BA74FF" />
  <rect x="202.039" y="362" width="41" height="14" rx="7" fill="#BA74FF" />
  <path
    d="M248.49 0H92.5101C90.0193 0 88 2.45062 88 5.4736V90.5264C88 93.5494 90.0193 96 92.5101 96H248.49C250.981 96 253 93.5494 253 90.5264V5.4736C253 2.45062 250.981 0 248.49 0Z"
    fill="#362C7B"
  />
  <path
    d="M240.86 29.0939H88.2227V14.8486H240.86C243.384 14.8486 245.433 17.3529 245.433 20.4394V23.5031C245.433 26.5896 243.384 29.0939 240.86 29.0939Z"
    fill="#35BAC2"
  />
  <mask
    id="mask6_956_7"
    style="mask-type:luminance"
    maskUnits="userSpaceOnUse"
    x="88"
    y="14"
    width="158"
    height="16"
  >
    <path
      d="M240.862 29.0939H88.2246V14.8486H240.862C243.386 14.8486 245.435 17.3529 245.435 20.4394V23.5031C245.435 26.5896 243.386 29.0939 240.862 29.0939Z"
      fill="white"
    />
  </mask>
  <g mask="url(#mask6_956_7)">
    <path
      d="M179.961 84.5005L267.398 34.7427L219.548 -11.0244L132.111 38.7333L179.961 84.5005Z"
      fill="#33D0DA"
    />
    <path
      d="M108.393 41.9783L161.42 11.8029L155.078 5.7373L102.051 35.9126L108.393 41.9783Z"
      fill="#33D0DA"
    />
  </g>
  <path
    d="M240.86 56.7199H88.2227V42.4746H240.86C243.384 42.4746 245.433 44.9789 245.433 48.0654V51.1291C245.433 54.2156 243.384 56.7199 240.86 56.7199Z"
    fill="#35BAC2"
  />
  <mask
    id="mask7_956_7"
    style="mask-type:luminance"
    maskUnits="userSpaceOnUse"
    x="88"
    y="42"
    width="158"
    height="15"
  >
    <path
      d="M240.862 56.7199H88.2246V42.4746H240.862C243.386 42.4746 245.435 44.9789 245.435 48.0654V51.1291C245.435 54.2156 243.386 56.7199 240.862 56.7199Z"
      fill="white"
    />
  </mask>
  <g mask="url(#mask7_956_7)">
    <path
      d="M149.29 130.071L271.609 60.4637L206.627 -1.68555L84.3086 67.9213L149.29 130.071Z"
      fill="#33D0DA"
    />
    <path
      d="M60.5901 71.1674L113.614 40.9953L107.272 34.9297L54.248 65.1018L60.5901 71.1674Z"
      fill="#33D0DA"
    />
  </g>
  <path
    d="M240.86 83.6467H88.2227V69.4014H240.86C243.384 69.4014 245.433 71.9057 245.433 74.9922V78.0559C245.433 81.1424 243.384 83.6467 240.86 83.6467Z"
    fill="#35BAC2"
  />
  <mask
    id="mask8_956_7"
    style="mask-type:luminance"
    maskUnits="userSpaceOnUse"
    x="88"
    y="69"
    width="158"
    height="15"
  >
    <path
      d="M240.862 83.6457H88.2246V69.4004H240.862C243.386 69.4004 245.435 71.9047 245.435 74.9912V78.0549C245.435 81.1414 243.386 83.6457 240.862 83.6457Z"
      fill="white"
    />
  </mask>
  <g mask="url(#mask8_956_7)">
    <path
      d="M247.352 67.5693H87.9609V85.8281H247.352V67.5693Z"
      fill="#33D0DA"
    />
  </g>
</svg>
